import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "lola-framework-ui-test/src/styles";
import "./lola-quote-reset.css";
import App from "./App.tsx";
import "./index.css";
import "./consumer-auth.css";
import { BrowserRouter } from "react-router-dom";
import "./locales/i18n.ts";
import { initAnalytics } from "./analytics";
import { ClerkConsumerRoot } from "./auth/ClerkConsumerRoot";
import { captureListStubFromUrl } from "./utils/listStub";

initAnalytics();
captureListStubFromUrl();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <ClerkConsumerRoot>
        <App />
      </ClerkConsumerRoot>
    </BrowserRouter>
  </StrictMode>
);
